import { plotFetch } from "./ApiRequest";

export const fetchInitialData = async (view: string | null, key: string | null, secret: string | null) => {
    try {
        if (view) {
            // If 'view' param is present, we assume user session authentication
            const response = await plotFetch(`/api/dashboard/project_info?view=${view}`, {
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: "include", // Include cookies for session auth
            });
            if (response.ok) {
                const data = await response.json();
                return data;
            } else {
                throw new Error(response.statusText || "Failed to fetch project info with user session");
            }
        }

        // Otherwise, use API key authentication
        const response = await plotFetch("/api/dashboard/project_info", {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Token ${key}:${secret}`,
            },
        });
        if (response.ok) {
            const data = await response.json();
            return data;
        } else {
            throw new Error(response.statusText || "Failed to fetch project info with API key");
        }
    } catch (error) {
        return error;
    }
};

export const TEXT_COLOR_OPTIONS = [
    { label: "Red", value: "#EF4444", className: "text-red-500" },
    { label: "Orange", value: "#FF9E00", className: "text-orange-500" },
    { label: "Yellow", value: "#FACC15", className: "text-yellow-500" },
    { label: "Green", value: "#22C55E", className: "text-green-500" },
    { label: "Blue", value: "#3B82F6", className: "text-blue-500" },
    { label: "Purple", value: "#A855F7", className: "text-purple-500" },
    { label: "Black", value: "#000000", className: "text-black" },
    { label: "White", value: "#FFFFFF", className: "text-white" },
];
